import * as React from "react";
const SvgFiRrScalpel = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-scalpel_svg__a)">
      <path
        fill="#062147"
        d="M23.12 1.88a3 3 0 0 0-4.241 0L.293 20.465a1 1 0 0 0-.281.554c-.058.372.015.922.388 1.358.243.284.706.622 1.523.622.474 0 .88.01 1.116 0a14.2 14.2 0 0 0 5.209-1.21c2.59-1.146 4.37-3.201 5.16-5.955l9.713-9.713a3 3 0 0 0 0-4.242M7.44 19.96c-1.425.63-2.932.98-4.48 1.041a6 6 0 0 1-.38.006l7.033-7.033 1.769 1.65c-.67 2.016-1.993 3.473-3.942 4.335M21.707 4.706l-9.217 9.217-1.463-1.364 9.266-9.267a.999.999 0 1 1 1.414 1.414"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-scalpel_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrScalpel;
